export const CONSENT_KEY = "recursosarg_consent_v1";

export const DEFAULT_PREFS = {
  necessary: true,
  analytics: false,
  ads: false,
  personalization: false,
};

function pushToDataLayer(payload) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

/** gtag wrapper that mirrors the snippet defined in public/index.html */
export function gtag() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export function readConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return {
      necessary: true,
      analytics: Boolean(parsed.analytics),
      ads: Boolean(parsed.ads),
      personalization: Boolean(parsed.personalization),
      timestamp: parsed.timestamp || null,
    };
  } catch (e) {
    return null;
  }
}

/** Reusable helper: pushes a Consent Mode v2 update to Google. */
export function updateConsent(prefs) {
  const granted = (flag) => (flag ? "granted" : "denied");

  gtag("consent", "update", {
    ad_storage: granted(prefs.ads),
    ad_user_data: granted(prefs.ads),
    ad_personalization: granted(prefs.personalization),
    analytics_storage: granted(prefs.analytics),
    personalization_storage: granted(prefs.personalization),
  });

  gtag("set", "ads_data_redaction", !prefs.ads);

  pushToDataLayer({
    event: "cookie_consent_update",
    consent_analytics: granted(prefs.analytics),
    consent_ads: granted(prefs.ads),
    consent_personalization: granted(prefs.personalization),
  });
}

export function saveConsent(prefs) {
  const payload = {
    necessary: true,
    analytics: Boolean(prefs.analytics),
    ads: Boolean(prefs.ads),
    personalization: Boolean(prefs.personalization),
    timestamp: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify(payload));
  } catch (e) {
    /* storage unavailable — consent still applied for this session */
  }
  updateConsent(payload);
  return payload;
}

export function clearConsent() {
  try {
    window.localStorage.removeItem(CONSENT_KEY);
  } catch (e) {
    /* noop */
  }
}

export function trackFormSubmission() {
  pushToDataLayer({ event: "contact_form_submit" });
}
